<template>
  <zen-one :showuserinfo="true" :title="'Selamat Datang Ke ARTIFICIAL INSEMINATION MANAGEMENT SYSTEM (AIMS)'">
   <div class="big-first-letter ">
    <w-select 
     class="mt4 role-selector" 
     :items="roles" 
     v-model="role_id"
     label="Pilih Peranan"
     placeholder="Sila pilih peranan Anda"
     outlined
     color="primary"
     large
     dark
   />
   <div v-if="role_id == '4' && stppPermissionLabels.length" class="mt2">
     <w-tag
        v-for="(item, i) in stppPermissionLabels"
        :key="i"
        :bg-color="item.color"
        round
        class="mr2"
      >
        {{ item.text }}
      </w-tag>

   </div>


  <!-- <zen-one :showuserinfo="true" :title="'Selamat Datang Ke ARTIFICIAL INSEMINATION MANAGEMENT SYSTEM (AIMS)' + $page.props.app_name"> -->
      <template  v-if="role_id == '1' || role_id == '6' || role_id == '14'">
         <!-- <z-page class="white--bg mt3 sh2" :title="'Status Pengguna'" >
            <Pengguna />
         </z-page> -->
         <z-page class="white--bg mt3 sh2" :title="'Dashboard'" >
            <DashboardAdmin :auth="auth" :d_tahun='tahun' :role_id="role_id"/>
         </z-page>
      </template>
      <template v-if=" role_id == '4'">
         <z-page class="white--bg mt3 sh2" :title="'Dashboard'" >
            <DashboardSttp :auth="auth" :d_tahun='tahun' :role_id="role_id"/>
         </z-page>
         <!-- <z-page class="white--bg mt3 sh2" :title="'Pengesahan Pengguna'" >
            <PermohonPengguna :auth="auth"/>
         </z-page> -->
         <!-- <z-page class="white--bg mt3 sh2" :title="'Permohonan Semen Beku (Permohonan STPP Negeri)'" >
            <SeSttp :auth="auth"/>
         </z-page> -->
         <!-- <z-page class="white--bg mt3 sh2" :title="'Permohonan Semen Beku (Permohonan AI MAN)'" >
            <SeAiman :auth="auth"/>
         </z-page>
         <z-page class="white--bg mt3 sh2" :title="'Permohonan Embrio Beku (Permohonan STPP Negeri)'" >
            <EmSttp :auth="auth"/>
         </z-page>
         <z-page class="white--bg mt3 sh2" :title="'Permohonan Embrio Beku (Permohonan AI MAN)'" >
            <EmAiman :auth="auth"/>
         </z-page> -->
      </template>
      <template  v-if="role_id == '7' || role_id == '9'">
         <z-page class="white--bg mt3 sh2" :title="'Dashboard'" >
            <DashboardAiman :auth="auth" :d_tahun='tahun' :role_id="role_id"/>
         </z-page>
         <!-- <z-page class="white--bg mt3 sh2" :title="'Permohonan Semen Beku (Permohonan AI MAN)'" >
            <SeAiman :auth="auth"/>
         </z-page> -->
      </template>
      <template  v-if="role_id == '8' || role_id == '10'">
         <z-page class="white--bg mt3 sh2" :title="'Dashboard'" >
               <DashboardEtman :auth="auth" :d_tahun='tahun' :role_id="role_id"/>
         </z-page>
         <!-- <z-page class="white--bg mt3 sh2" :title="'Permohonan Embrio Beku (Permohonan AI MAN)'" >
               <EmAiman :auth="auth"/>
         </z-page> -->
      </template>

      <!-- <template  v-if="$zutil.anyRole(['8','7', '1'])">
         <z-page class="white--bg mt3 sh2" :title="'Permohonan Ai Semulajadi'" >
               <Semulajadi :auth="auth" :d_tahun='tahun'/>
         </z-page>
         <z-page class="white--bg mt3 sh2" :title="'Permohonan Ai Sinkronisasi'" >
               <Sinkronisasi :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template> -->


      <template v-if="role_id == '3' || role_id == '11' ">
         <z-page class="white--bg mt3 sh2" :title="'Dashboard'" >
               <DashboardIbvk :auth="auth" :d_tahun='tahun' :role_id="role_id"/>
         </z-page>
         <!-- <z-page class="white--bg mt3 sh2" :title="'Permohonan Semen Beku (Pengesahan IBVK)'" >
            <SeIbvk :auth="auth" :d_tahun='tahun'/>
         </z-page>
         <z-page class="white--bg mt3 sh2" :title="'Permohonan Embrio Beku (Pengesahan IBVK)'" >
            <EmIbvk :auth="auth" :d_tahun='tahun'/>
         </z-page> -->
      </template>

      <!-- <template v-if="$zutil.anyRole(['6'])">
         <z-page class="white--bg mt3 sh2" :title="'Status Baka'" >
            <Baka :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template> -->
      
<!-- <div class="w-flex wrap smd-column" >
    <div class="grow " >
    <template v-if="$zutil.anyRole(['1','3'])">
       <z-page class="white--bg mt3 sh2" :title="'Katalog Semen'" >
          <Katalog :auth="auth" :d_tahun='tahun'/>
       </z-page>
    </template>
 </div>
 <div class="grow " >
    <template v-if="$zutil.anyRole(['1','3'])">
        <z-page class="white--bg mt3 sh2" :title="'Katalog Embrio'" >
          <Katalog1 :auth="auth" :d_tahun='tahun'/>
       </z-page>
    </template>
 </div>
</div>
<div class="w-flex wrap smd-column" >
   <div class="grow " >
      <template v-if="$zutil.role('1') || $zutil.role('3')">
         <z-page class="white--bg mt3 sh2" :title="'Pemungutan'" >
            <Pemungutan :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template>
   </div>
</div>
<div class="w-flex wrap smd-column" >
  <div class="grow " >
    <template v-if="$zutil.anyRole(['1','3'])">
     <z-page class="white--bg mt3 sh2" :title="'Pengeluaran'" >
        <Pengeluaran :auth="auth" :d_tahun='tahun'/>
     </z-page>
  </template>
 </div>
</div>
<template v-if="$zutil.anyRole(['1','3'])">
   <z-page class="white--bg mt3 sh2" :title="'Status Kawalan'" >
      <Kawalan :auth="auth" :d_tahun='tahun'/>
   </z-page>
</template>
<div class="w-flex wrap smd-column" >
  <div class="grow " >
      <template v-if="$zutil.anyRole(['1','3'])">
         <z-page class="white--bg mt3 sh2" :title="'Pendaftaran Semen IBVK'" >
            <Semen :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template>
   </div>
   <div class="grow " >
      <template v-if="$zutil.anyRole(['1','3'])">
         <z-page class="white--bg mt3 sh2" :title="'Perikodan Semen IMPORT'" >
            <Semen1 :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template>
   </div>
</div>
<div class="w-flex wrap smd-column" >
   <div class="grow " >
      <template v-if="$zutil.anyRole(['1','3'])">
         <z-page class="white--bg mt3 sh2" :title="'Pendaftaran Embrio IBVK'" >
            <Embrio :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template>
   </div>
   <div class="grow " >
      <template v-if="$zutil.anyRole(['1','3'])">
         <z-page class="white--bg mt3 sh2" :title="'Perikodan Embrio Import'" >
            <Embrio1 :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template>
   </div>
</div> -->
<!-- <div class="w-flex wrap smd-column" >
   <div class="grow " >
      <template v-if="$zutil.role('1') || $zutil.role('3')">
         <z-page class="white--bg mt3 sh2" :title="'Daftar Tangki LN2'" >
            <Daftar :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template>
   </div>
   <div class="grow " >
      <template v-if="$zutil.role('1') || $zutil.role('3')">
         <z-page class="white--bg mt3 sh2" :title="'Perolehan LN2'" >
            <Perolehan :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template>
   </div>
</div>
<div class="w-flex wrap smd-column" >
   <div class="grow " >
      <template v-if="$zutil.role('1') || $zutil.role('3')">
         <z-page class="white--bg mt3 sh2" :title="'Pengagihan LN2'" >
            <Agihan :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template>
   </div>
   <div class="grow " >
      <template v-if="$zutil.role('1') || $zutil.role('3')">
         <z-page class="white--bg mt3 sh2" :title="'Selenggara Tangki LN2'" >
            <Selenggara :auth="auth" :d_tahun='tahun'/>
         </z-page>
      </template>
   </div>   
</div> -->
<div class="w-flex wrap smd-column" >
   <div class="grow " >
      <template v-if="role_id == '2' || role_id == '5'">
         <z-page class="white--bg mt3 sh2" :title="'Dashboard'" >
            <Ternakan :auth="auth" :d_tahun='tahun' :role_id="role_id"/>
         </z-page>
      </template>
   </div>
</div>
    <!-- <z-page class="white--bg mt3 sh2" :title="'Dashboard'" > -->
       <!-- <template v-if="$zutil.role('Pentadbir Sistem')">
         <Pentadbir />
       </template>
       <template v-if="$zutil.role('Penternak')">
         <Peternak />
       </template>
       <template v-if="$zutil.role('Al Man')">
         <Alman />
       </template> -->
    <!-- </z-page> -->
 </div>
  </zen-one>|
</template>
<script>
import Pentadbir from './Dashboard/Pentadbir.vue';
import Peternak from './Dashboard/Peternak.vue';
import Alman from './Dashboard/Alman.vue';
import Pengguna from './Dashboard/Pengguna.vue';
import PermohonPengguna from './Dashboard/PermohonPengguna.vue';
import DashboardSttp from './Dashboard/DashboardSttp.vue';
import DashboardAiman from './Dashboard/DashboardAiman.vue';
import DashboardEtman from './Dashboard/DashboardEtman.vue';
import DashboardIbvk from './Dashboard/DashboardIbvk.vue';
import DashboardAdmin from './Dashboard/DashboardAdmin.vue';
import Kawalan from './Dashboard/Kawalan.vue';
import Katalog from './Dashboard/KatalogSemen.vue';
import Katalog1 from './Dashboard/KatalogEmbrio.vue';
import Semen from './Dashboard/SemenIbvk.vue';
import Semen1 from './Dashboard/SemenImport.vue';
import Embrio from './Dashboard/EmbrioIbvk.vue';
import Embrio1 from './Dashboard/EmbrioImport.vue';
import Pemungutan from './Dashboard/Pemungutan.vue';
import Pengeluaran from './Dashboard/Pengeluaran.vue';
import SeAiman from './Dashboard/Permohonan/SeAiman.vue';
import SeSttp from './Dashboard/Permohonan/SeSttp.vue';
import SeIbvk from './Dashboard/Permohonan/SeIbvk.vue';
import EmAiman from './Dashboard/Permohonan/EmAiman.vue';
import Semulajadi from './Dashboard/Art/AiSemulajadi.vue';
import Sinkronisasi from './Dashboard/Art/AiSinkronisasi.vue';
import EmSttp from './Dashboard/Permohonan/EmSttp.vue';
import EmIbvk from './Dashboard/Permohonan/EmIbvk.vue';
import Daftar from './Dashboard/TangkiDaftar.vue';
import Perolehan from './Dashboard/TangkiPerolehan.vue';
import Agihan from './Dashboard/TangkiPengagihan.vue';
import Ternakan from './Dashboard/Ternakan.vue';
import Selenggara from './Dashboard/TangkiSelenggara.vue';
import Baka from './Dashboard/Baka.vue';
export default {
props: {
    auth: [Array, Object],
    roles: [Array, Object],
    role: String,
},
components: {
    Pentadbir,Peternak,Alman,PermohonPengguna, Pengguna, Kawalan, Katalog, Katalog1, Semen ,Semen1, Embrio, Embrio1, Pemungutan, Pengeluaran, SeAiman, SeSttp, SeIbvk, Daftar, Perolehan, Agihan, Selenggara, EmAiman, EmSttp, EmIbvk, Ternakan, Semulajadi, Sinkronisasi, Baka, DashboardSttp, DashboardAiman,DashboardEtman,DashboardIbvk,DashboardAdmin
},
computed: {
  stppPermissionLabels() {
    const perms = this.auth?.permissions || []
    const labels = []

    if (perms.includes('3')) {
      labels.push({
        text: 'Penyelaras',
        color: 'success'
      })
    }

    if (perms.includes('4')) {
      labels.push({
        text: 'Pegawai',
        color: 'info'
      })
    }

    return labels
  }
},
data() { return {
  errors: [],
  // item_roles : this.roles,
  role_id : this.role,
  crumbs: [
    { label: this.$page.props.app_name, route: '/home' },
  ],
  tahun:[],
  

}},
methods: {
   getTahun(){
      this.$zcomm.get(this.api_service + 'lookup/tahun', {}).then(res => {
        this.tahun = res
      })
   },
 
  
},

   mounted() {
       this.getTahun();
       this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
       // if(this.params.l == 1){
       //   window.location.replace(window.location.pathname);
       // }
       // else{
         
       // }
   }
   }

</script>

<style>
.w-card {
    z-index: 9;
}

.role-selector {
  width: 100%;
  max-width: 400px;
  border: 2px solid #1976d2;
  border-radius: 8px;
  background-color: #f5f5f5;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-weight: bold;
}

.role-selector .w-select__selection {
  padding: 12px 16px;
  font-size: 16px;
}

.role-selector .w-select__label {
  font-weight: bold;
  color: #1976d2;
}
</style>
